import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

export namespace AMapMarkerClusterer {
  export interface StyleObject {
    url?: string;
    size?: AMap.Size;
    offset?: AMap.Pixel;
    imageOffset?: AMap.Pixel;
    textColor?: string;
    textSize?: number;
  }

  export interface Options {
    /**
     * èåè®¡ç®æ¶ç½æ ¼çåç´ å¤§å°ï¼é»è®¤60
     */
    gridSize?: number;
    /**
     * èåçæå°æ°éãé»è®¤å¼ä¸º2ï¼å³å°äº2ä¸ªç¹åä¸è½æä¸ºä¸ä¸ªèå
     */
    minClusterSize?: number;
    /**
     * æå¤§çèåçº§å«ï¼å¤§äºè¯¥çº§å«å°±ä¸è¿è¡ç¸åºçèåãé»è®¤å¼ä¸º18
     */
    maxZoom?: number;
    /**
     * èåç¹çå¾æ ä½ç½®æ¯å¦æ¯ææèååç¹çä¸­å¿ç¹ãé»è®¤ä¸ºå¦
     */
    averageCenter?: boolean;
    /**
     * æå®èååçç¹æ è®°çå¾æ æ ·å¼ï¼å¯ç¼ºçï¼ç¼ºçæ¶ä¸ºé»è®¤æ ·å¼
     */
    styles?: StyleObject[];
    /**
     * è¯¥æ¹æ³ç¨æ¥å®ç°èåç¹çèªå®ä¹ç»å¶
     */
    renderClusterMarker?: (obj: {
      count: number;
      markers: AMap.Marker<any>[];
      marker: AMap.Marker<any>;
    }) => void;
    /**
     * ç¹å»èåç¹æ¶ï¼æ¯å¦æ£å¼ï¼é»è®¤å¼ä¸ºï¼true
     */
    zoomOnClick?: boolean;
  }
}

const TAG = 'AmapMarkerCluster';

@Injectable()
export class AmapMarkerClustererService implements Getter<any> {
  private markerClusterer: any;
  private markerClusterer$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private plugins: PluginLoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åç¹èå
   */
  get() {
    return this.markerClusterer$.asObservable();
  }

  /**
   * åå»ºç¹èå AMap.MarkerClusterer
   * @param options éé¡¹
   */
  create(options: AMapMarkerClusterer.Options) {
    return zip(this.amaps.get(), this.plugins.load('AMap.MarkerClusterer')).pipe(
      map(([m]) => {
        this.markerClusterer = this.ngZone.runOutsideAngular(
          () => new AMap.MarkerClusterer(m, [], options),
        );
        this.logger.d(TAG, 'new markerClusterer created.');
        this.markerClusterer$.next(this.markerClusterer);
        this.markerClusterer$.complete();
        return this.markerClusterer;
      }),
    );
  }

  /**
   * éæ¯ç¹èå
   */
  destroy() {
    this.get().subscribe(m => {
      m.clearMarkers();
      m.setMap(null);
      this.logger.d(TAG, 'markerClusterer destroyed.');
      this.markerClusterer = null;
    });
  }
}
